import { Box, Drawer, Stack } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Logo from 'src/components/Logo';
import { NavSectionVertical } from 'src/components/nav-section';
import Scrollbar from 'src/components/Scrollbar';
import useAuth from 'src/hooks/useAuth';
import useCollapseDrawer from 'src/hooks/useCollapseDrawer';
import useResponsive from 'src/hooks/useResponsive';
import cssStyles from 'src/utils/cssStyles';
import { NAVBAR } from '../../../config';
// import { AdminNavConfig } from './AdminNavConfig';
import CollapseButton from './CollapseButton';
import NavbarAccount from './NavbarAccount';
// import { NavConfig } from './NavConfig';
import { useDispatch, useSelector } from 'src/redux/store';
import { getMenu } from 'src/redux/slices/menu';
import useCompany from 'src/hooks/useCompany';
import TextBox from '@component/form/textbox';

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------

NavbarVertical.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function NavbarVertical({ isOpenSidebar, onCloseSidebar }) {
  const theme = useTheme();

  const { pathname } = useRouter();
  const { companyId } = useCompany();
  const [searchMenu, setSearchMenu] = useState("");
  // const { user } = useAuth();
  // const isSuperAdmin = user?.roles?.map((role) => role.id).includes(1);
  const { menus } = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  const isDesktop = useResponsive('up', 'lg');

  const { isCollapse, collapseClick, collapseHover, onToggleCollapse, onHoverEnter, onHoverLeave } =
    useCollapseDrawer();

  useEffect(() => {
    dispatch(getMenu());
  }, [dispatch, companyId]);

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleMenuSearch = (e) => {
    const string = e?.target?.value;
    setSearchMenu(string);
  }

  function getObject(object, string) {
    let result = [];
    if (!object || typeof object !== 'object') return;
    Object.values(object).some(v => {
      const lowerString = string.toLowerCase();
      if (v == lowerString) return result = object;
      return result = getObject(v, string);
    });
    return result;
  }

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          ...(isCollapse && { alignItems: 'center' }),
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Logo />

          {isDesktop && !isCollapse && (
            <CollapseButton onToggleCollapse={onToggleCollapse} collapseClick={collapseClick} />
          )}
        </Stack>

        <NavbarAccount isCollapse={isCollapse} />
      </Stack>
      <TextBox
        fullWidth
        name="uid"
        value={searchMenu}
        placeholder={"Search Menu"}
        onChange={handleMenuSearch}
        sx={{marginLeft: "20px", marginRight: "20px", backgroundColor: 'white', borderRadius: '10px'}}
      />
      <NavSectionVertical
        navConfig={getObject(menus, searchMenu) ? [{"items" : [getObject(menus, searchMenu)]}] : menus}
        isCollapse={isCollapse}
        isSideMenu={true}
      />

      <Box sx={{ flexGrow: 1 }} />

      {/* {!isCollapse && <NavbarDocs />} */}
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH,
        },
        ...(collapseClick && {
          position: 'absolute',
        }),
      }}
    >
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          sx={{
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              backgroundColor: '#3B48A1',
            },
          }}
          PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          sx={{
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              backgroundColor: '#3B48A1',
              color: '#fff',
            },
          }}
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              borderRightStyle: 'dashed',
              bgcolor: 'background.default',
              transition: (theme) =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.standard,
                }),
              ...(isCollapse && {
                width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
              }),
              ...(collapseHover && {
                ...cssStyles(theme).bgBlur(),
                boxShadow: (theme) => theme.customShadows.z24,
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
